import {
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  FacebookIcon,
  WhatsappIcon,
  TwitterIcon,
} from "react-share";
import { useState } from "react";

import { useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";

import FiShare2 from '@meronex/icons/fi/FiShare2';
import { deepOrange } from "@material-ui/core/colors";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import { firestore, storage } from "../firebase";

const useStyles = makeStyles((theme) => ({
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  usernameIcon: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    cursor: "pointer",
  },
  orange: {
    color: theme.palette.getContrastText(deepOrange[500]),
    backgroundColor: deepOrange[500],
  },
  menu: {
    marginTop: 30,
  },
}));

function ShareButton() {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [image, setImageLink] = useState();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const { currentUser = {} } = useSelector((state) => ({
    currentUser: state.currentUser,
  }));

  const generateUrl = async (event) => {
    setLoading(true);
    setAnchorEl(event.currentTarget);
    const store = window.store;
    const base64 = store.toDataURL({ ignoreBackground: false });
    const child = `${currentUser.uid}/saved/${new Date().getTime()}`;
    const storageRef = await storage
      .ref()
      .child(child)
      .putString(base64, "data_url");
    const imageLink = await storageRef.ref.getDownloadURL();
    await firestore.collection("saved").add({
      userId: currentUser.uid,
      url: imageLink,
    });
    setLoading(false);
    setImageLink(imageLink);

  };

  return (
    <>
      <Grid item xs={2} md={2} className={classes.usernameIcon}>
        <div onClick={generateUrl}>
          <FiShare2 className="bp3-icon" style={{ fontSize: "20px" }} />
          
        </div>
      </Grid>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        className={classes.menu}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {loading ? (
          <MenuItem>Loading...</MenuItem>
        ) : (
          <>
            {" "}
            <MenuItem>
              <FacebookShareButton
                url={image}
                quote={"Made with Jazzu Designer"}
                hashtag="#jazzu-designer"
                className={classes.socialMediaButton}
              >
                <FacebookIcon size={24} /> Facebook
              </FacebookShareButton>
            </MenuItem>
            <MenuItem>
              <TwitterShareButton
                url={image}
                title={"Made with Jazzu Designer"}
                hashtag="#jazzu-designer"
                className={classes.socialMediaButton}
              >
                <TwitterIcon size={24} /> Twitter
              </TwitterShareButton>
            </MenuItem>
            <MenuItem>
              <WhatsappShareButton
                url={image}
                title={"Made with Jazzu Designer"}
                separator=":: "
                className={classes.socialMediaButton}
              >
                <WhatsappIcon size={24} /> Whatsapp
              </WhatsappShareButton>
            </MenuItem>
          </>
        )}
      </Menu>
    </>
  );
}

export default ShareButton;
